import { useTranslation } from 'react-i18next'

import { isLanguage } from '../../../types/language'
import { LocaleIdentifier } from '../../../types/localeIdentifier'
import { languageToLocale } from '../../../utils/languageToLocale'

export const useDemoInvoiceLocale = (): LocaleIdentifier => {
  const { i18n } = useTranslation()

  return languageToLocale[isLanguage(i18n.language) ? i18n.language : 'en']
}
